module.exports = __webpack_public_path__ + "static/media/tip_dog_temperature_fr.2c87355c.png";